function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
export var flash = new ( /*#__PURE__*/function () {
  function Flash() {
    var _this = this;
    _classCallCheck(this, Flash);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  _createClass(Flash, [{
    key: "init",
    value: function init() {
      if (!$('#flash-container').length) {
        $('body').append('<div id="flash-container">  </div>');
      }
      vent.on('FLASH:SHOW', this.onShowFlash.bind(this));
      vent.on('FLASH:CLEAR', this.onClearFlash.bind(this));
      $(document).on('click', '[data-flash-close]', this.closeFlash.bind(this));
      // $(document).on('mouseenter', '.flash', this.pauseFlash.bind(this));
      // $(document).on('mouseleave', '.flash', this.startFlash.bind(this));

      if (window.flash_force) {
        vent.publish('FLASH:SHOW', window.flash_force);
      }
    }
  }, {
    key: "closeFlash",
    value: function closeFlash(e, $flash) {
      if (!$flash && e) {
        e.stopPropagation();
        $flash = $(e.target).parents('.flash');
      }
      clearTimeout($flash.data('timeout'));
      $flash.remove();
    }
  }, {
    key: "pauseFlash",
    value: function pauseFlash(e) {
      var $flash = $(e.target);
      e.stopPropagation();
      clearTimeout($flash.data('timeout'));
      var elapsedFromStart = ($flash.data('timeoutStart') || 0) - Date.now();
      var elapedTotal = ($flash.data('timeoutElapsed') || 0) - elapsedFromStart;
      $flash.data('timeout', null).data('timeoutStart', null).data('timeoutElapsed', elapedTotal);
    }
  }, {
    key: "startFlash",
    value: function startFlash(e, $flash) {
      if (!$flash && e) {
        e.stopPropagation();
        $flash = $(e.target);
      }
      var elapedTotal = $flash.data('timeoutElapsed') || 0;
      var delay = 6000 - elapedTotal;
      $flash.data('timeoutStart', Date.now());
      $flash.data('timeout', setTimeout(this.closeFlash.bind(this, null, $flash), delay));
    }
  }, {
    key: "onClearFlash",
    value: function onClearFlash() {
      var that = this;
      $('#flash-container .flash').each(function () {
        that.closeFlash(null, $(this));
      });
    }
  }, {
    key: "onShowFlash",
    value: function onShowFlash(_ref) {
      var flash = _ref.flash,
        error = _ref.error;
      vent.publish('FLASH:CLEAR');
      if (error === false) {
        flash = '<span class="flash-icon is-ok"><svg viewBox="0 0 30 30" aria-hidden="true" focusable="false" tabindex="-1" class="icon"><use xlink:href="#icon-noun-check"></use></svg></span>' + flash;
      } else if (error === true) {
        flash = '<span class="flash-icon is-ko"><svg viewBox="0 0 30 30" aria-hidden="true" focusable="false" tabindex="-1" class="icon"><use xlink:href="#icon-cancel"></use></svg></span>' + flash;
      }
      $('#flash-container').append('<div class="flash"><div class="flash-inside"><span>' + flash + '</span><span class="flash-sep"></span><a data-flash-close class="flash__close" href="javascript:;">&times;</a><a data-flash-close class="flash__closing btn btn-border" href="javascript:;">Fermer</a></div><div class="flash-overlay" data-flash-close></div></div>');
      var $flash = $('#flash-container .flash').last();
      // this.startFlash(null, $flash);
    }
  }]);
  return Flash;
}())();